<button
  class="button-base"
  [type]="submit() ? 'submit' : 'button'"
  [class]="{
    'button-primary': type() === ButtonType.primary,
    'button-secondary': type() === ButtonType.secondary,
    'button-tertiary': type() === ButtonType.tertiary,
    'button-link': type() === ButtonType.link,
    'button-primary-dark': type() === ButtonType.primaryDark,
    'button-secondary-dark': type() === ButtonType.secondaryDark,
    'button-tertiary-dark': type() === ButtonType.tertiaryDark,
    'button-link-dark': type() === ButtonType.linkDark,
    'button-large': size() === InputSize.large,
    'button-small': size() === InputSize.small,
    'button-loading': loading(),
    'w-100': fullWidth(),
  }"
  [disabled]="disabled() || loading()"
  (click)="!disabled() && buttonClick.emit()">
  <div class="d-flex justify-content-center align-items-center button-content">
    @if (leadingIconName()) {
      <mat-icon class="button-icon" [svgIcon]="leadingIconName() ?? ''"></mat-icon>
    }
    @if (loading()) {
      <div class="loading-indicator-container">
        <div class="loading-indicator">
          <mat-icon class="loading-indicator-icon" [svgIcon]="'loading'"></mat-icon>
        </div>
      </div>
    } @else {
      <div class="button-title">
        <ng-content></ng-content>
      </div>
    }
    @if (trailingIconName()) {
      <mat-icon class="button-icon" [svgIcon]="trailingIconName() ?? ''"></mat-icon>
    }
  </div>
</button>
